import React from 'react'

import "../styles/BlackDiv.css"

const BlackDiv = () => {
  return (
    <div className='black-div'>
        <div className='inner-div'>
        <img src="https://cdn.plotch.io/image/upload/C/V/1660916598_MS5wbmc=.png" alt="" />
        <img src="https://cdn.plotch.io/image/upload/C/V/1660916607_Mi5wbmc=.png" alt="" />
        <img src="https://cdn.plotch.io/image/upload/C/V/1660916612_My5wbmc=.png" alt="" />
        <img src="https://cdn.plotch.io/image/upload/C/V/1660916617_NC5wbmc=.png" alt="" />
        <img src="https://cdn.plotch.io/image/upload/C/V/1660916629_NS5wbmc=.png" alt="" />
        </div>
       

    </div>
  )
}

export default BlackDiv